<template>
  <div>
    <!-- youtube -->
    <div class="video-container" v-if="!loading">
      <youtube
        :video-id="videoId"
        :mute="muted"
        :player-vars="playerVars"
        @playing="onPlayerPlaying"
        @ended="onPlayerEnded"
        @paused="onPlayerPause"
        @ready="onReady"
        host="https://www.youtube-nocookie.com"
      ></youtube>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
const APP_BASE_URL = process.env.VUE_APP_BASE_URL;
import { mapState } from "vuex";

export default {
  name: "YoutubeComponent",
  data() {
    return {
      player: null,
      loading: true,
      videoId: "",
      muted: false,
      playerVars: {
        rel: 0,
        showinfo: 0,
        autohide: 1,
        wmode: "opaque",
        enablejsapi: 1,
        html5: 1
      },
      youtubePattern: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/
    };
  },

  async mounted() {
    console.log("[Youtube] mounted");
    this.loading = true;
    const result = this.content.stream_url.match(this.youtubePattern);
    this.videoId = result[5];
    if (this.content.autoplay) this.playerVars.autoplay = 1;
    if (this.content.mute) this.muted = true;
    this.loading = false;
  },

  computed: {
    ...mapState(["content", "gatePass", "user"])
  },
  async beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.$store.commit("SET_VIDEO_PLAYING", false);
      await this.$store.dispatch("offline");
    }
  },
  methods: {
    onReady(player) {
      const ifr = document.querySelector(".video-container iframe");
      ifr.setAttribute("width", "100%");
      ifr.setAttribute("height", "100%");
    },
    async onPlayerPause(player) {
      console.log("[VideoPlayer] player pause!", player);
      this.$store.commit("SET_VIDEO_PLAYING", false);
      await this.$store.dispatch("offline");
    },
    async onPlayerEnded(player) {
      console.log("[VideoPlayer] player ended!", player);
      this.$store.commit("SET_VIDEO_PLAYING", false);
      await this.$store.dispatch("offline");
    },
    onPlayerWaiting(player) {
      console.log("[VideoPlayer] player Waiting!", player);
    },
    async onPlayerPlaying(player) {
      console.log("[VideoPlayer] player Playing!", player);
      this.$store.commit("SET_VIDEO_PLAYING", true);
      // online 중임을 알림
      await this.$store.dispatch("online");
    },
    onPlayerCanplaythrough(player) {
      // console.log('player Canplaythrough!', player)
    }
  }
};
</script>

<style scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}
.video-container div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.video-container div iframe {
  width: 100%;
  height: 100%;
}
</style>
